import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";

import { textCapitalized } from "../../common/components/Utils";
import { connect } from "react-redux";
import { getCaseApproverLogs } from "../../../store/discipline/actions";

const ViewCaseLogs = (props) => {
  const { caseApproverLogs, getCaseApproverLogs, caseId } = props;
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getCaseApproverLogs(caseId, setIsLoading);
  }, [caseId]);
  return (
    <>
      <div>
        <Box sx={{ width: "100%" }}>
          <React.Fragment>
            <div
              style={{
                width: "100%",
              }}
            >
              <p className="contact_p">
                {isLoading ? (
                  <Box
                    className="justify-content-center "
                    sx={{ display: "flex" }}
                  >
                    {" "}
                    <CircularProgress />
                  </Box>
                ) : (
                  <>
                    {!!caseApproverLogs.length ? (
                      <>
                        <table style={{ marginTop: 8, marginBottom: 8 }}>
                          <tbody>
                            {caseApproverLogs.map((log, index) => (
                              <>
                                <div key={index} className="row">
                                  <div className="col-12 py-2">
                                    <Card sx={{ width: "100%" }}>
                                      <CardHeader
                                        avatar={
                                          <Avatar
                                            sx={{
                                              bgcolor: "#ccc",
                                            }}
                                          >
                                            {log.firstName
                                              .charAt(0)
                                              .toUpperCase()}
                                          </Avatar>
                                        }
                                        title={`${log.firstName}`}
                                        subheader={moment(
                                          log?.createdOn
                                        ).format("lll")}
                                        action={
                                          <span className="text-primary">
                                            {log?.isMinister ? (
                                              <>
                                                <small
                                                  className={`ml-1 fw-bold text-truncate text-primary`}
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {textCapitalized(
                                                    log?.positionName || ""
                                                  )}
                                                </small>
                                              </>
                                            ) : (
                                              <>
                                                <small
                                                  className="fw-bold text-truncate text-dark"
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {textCapitalized(
                                                    log?.institutionName || ""
                                                  )}
                                                </small>
                                                <span
                                                  style={{ fontSize: "12px" }}
                                                  className="fas fa-angle-right ml-1"
                                                ></span>
                                                <small
                                                  className={`ml-1 fw-bold text-truncate text-primary`}
                                                  style={{ fontSize: "12px" }}
                                                >
                                                  {textCapitalized(
                                                    log?.positionName || ""
                                                  )}
                                                </small>
                                              </>
                                            )}
                                          </span>
                                        }
                                      />

                                      <CardContent>
                                        <Typography
                                          style={{
                                            marginTop: "-15px",
                                          }}
                                          variant="body2"
                                          color="text.secondary"
                                        >
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: log.description,
                                            }}
                                          ></span>
                                        </Typography>
                                      </CardContent>
                                      <CardActions>
                                        {log.title && (
                                          <span className="badge bg-dark text-white px-2">
                                            {log.title}
                                          </span>
                                        )}
                                      </CardActions>
                                    </Card>
                                  </div>
                                </div>
                              </>
                            ))}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <>
                        <div
                          className="card  w-100 mb-2"
                          style={{
                            backgroundColor: "#fff",
                            borderLeft: "2px solid #3f51b5",
                            borderLeft: "2px solid #3f51b5",
                            borderRadius: "4px",
                          }}
                        >
                          <div className="card-body w-100">
                            <p className="small p-0 ms-2 mb-0 rounded-3">
                              No Approve's logs found
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </p>
            </div>
          </React.Fragment>
        </Box>
      </div>
    </>
  );
};

const mapStateToProps = ({ loading, caseApproverLogs }) => {
  return {
    loading,
    caseApproverLogs,
  };
};

export default connect(mapStateToProps, {
  getCaseApproverLogs,
})(ViewCaseLogs);
